import type { SupportMenuItemContent, SupportMenuItemProps } from './support-menu-item.types';
import { cn } from '../../utils/cn';
import { useMemo } from 'react';

import styles from './support-menu-item.module.css';

export const useSupportMenuItemView = ({
    titleClassname,
}: Pick<SupportMenuItemProps, 'iconProps' | 'titleClassname'>) => {
    const titleProps: SupportMenuItemContent['labelProps'] = useMemo(() => {
        return {
            className: cn(styles.title, titleClassname),
        };
    }, [titleClassname]);

    const rightIcon: SupportMenuItemContent['trailingIconProps'] = useMemo(() => {
        return {
            name: 'chevron-right',
            className: styles.chevronRight,
        };
    }, []);

    return {
        titleProps,
        rightIcon,
    };
};
